import React, { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from 'antd';
const { Header, Content } = Layout;
import ProfileIcon from '@totem/components/common/profileIcon/ProfileIcon';
import ReportsContainer from '@totem/components/reports/ReportsContainer';
import { RouteContextProvider } from '@totem/components/RouteContext';
import TenantLeftNav from '@totem/components/TenantLeftNav';
import NotFound from '@totem/components/ui_components/pageExceptions/notFound/NotFound';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { getTenantRoutes } from '@totem/routes/routes';
import colors from '@totem/styles/colors';

const styles = {
  content: {
    backgroundColor: colors.neutral.white,
    display: 'flex',
    flexDirection: 'column' as any,
  },
  header: {
    background: colors.neutral.white,
    padding: 0,
    display: 'flex',
    flexDirection: 'row' as any,
    justifyContent: 'flex-end',
    alignItems: 'center',
    borderBottom: `2px solid ${colors.neutral.typhoon}`,
  },
};

const TenantBase = () => {
  const { userProfile } = useContext(UserProfileContext);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <ReportsContainer>
        <TenantLeftNav />
      </ReportsContainer>
      <Layout>
        <Header style={styles.header}>
          <ProfileIcon />
        </Header>
        <Content style={styles.content}>
          <Routes>
            {getTenantRoutes(userProfile).map((route) => {
              const enabled =
                typeof route.render === 'function'
                  ? route.render(userProfile)
                  : (route.render ?? true);

              return (
                enabled && (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <RouteContextProvider value={route}>
                        <route.component />
                      </RouteContextProvider>
                    }
                  />
                )
              );
            })}
            <Route element={<NotFound />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default TenantBase;
